import { ArgsType, Field, Int } from '@nestjs/graphql'
// The nest-scoped fork, not bare `class-validator`: the client apps compile this package from
// source and their bundles carry no such dependency, so importing the bare one breaks the website
// build. Everything else decorated in `common` uses the scoped one for the same reason.
import { ArrayNotEmpty, IsArray, IsOptional, Matches } from '@nestjs/class-validator'

@ArgsType()
export class BookAppleBooksCodesArgs {
  @Field(t => Int)
  bookId!: number
}

@ArgsType()
export class AddBookAppleBooksCodesArgs {
  @Field(t => Int)
  bookId!: number

  @Field(t => [String])
  @IsArray()
  @ArrayNotEmpty()
  codes!: string[]

  /**
   * The expiry shared by every code in this batch, as the calendar day `YYYY-MM-DD`. Optional so the
   * mutation can still be used for codes an author has no date for, which is the state every
   * pre-sc-28048 code is already in.
   *
   * A day rather than a DateTime on purpose: the picker hands back local midnight, and sending that
   * instant put a BST author's choice on the previous UTC day.
   */
  @Field({ nullable: true })
  @IsOptional()
  @Matches(/^\d{4}-\d{2}-\d{2}$/, { message: 'expirationDate must be YYYY-MM-DD' })
  expirationDate?: string
}

@ArgsType()
export class RemoveBookAppleBooksCodeArgs {
  @Field(t => Int)
  bookId!: number

  @Field(t => Int)
  id!: number
}
